import { Logo } from "./Logo.js";
import "./Header.css";

/**
 * Fixed-height brand header for the dashboard — logo only, no navigation lives here.
 *
 * The bottom edge is clipped into the wave shape ripped from startle.io's hero
 * (assets/hero-wave.svg, a 1440x64 path with fill #0F1317 — that colour is what
 * AttractScreen's top-of-page gradient starts from, so the header appears to melt into it).
 * `clipPathUnits="objectBoundingBox"` normalizes the source path to 0–1, so the clip scales
 * with the header's actual box instead of the source's fixed 1440x64 pixels.
 */
export function Header(): React.JSX.Element {
  return (
    <header className="kiosk-header">
      {/* Zero-size — only the <clipPath> def is used, via `clip-path: url(#header-wave-clip)`. */}
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
        <defs>
          <clipPath id="header-wave-clip" clipPathUnits="objectBoundingBox">
            {/* Same curve as before, halved again — now confined to the bottom eighth (y:
                0.875–1) of the header's height; the rest stays a flat rectangle. */}
            <path d="M0 0 L1 0 L1 0.9342 C0.8939 0.9733 0.8112 0.9928 0.7519 0.9928 C0.6629 0.9928 0.3781 0.8822 0.2521 0.8756 C0.1681 0.8712 0.084 0.8908 0 0.9342 Z" />
          </clipPath>
        </defs>
      </svg>
      <Logo size="header" />
    </header>
  );
}
